var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMxn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.82825 0.408203H0.259766V11.6815H5.82825V0.408203Z",
    fill: "#006747"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0836 0.408173H11.5151V11.6815H17.0836V0.408173Z",
    fill: "#CD1225"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3966 0.408173H5.82812V11.6815H11.3966V0.408173Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5672 7.17214L10.6857 7.29081L10.4487 7.17214V7.05347L10.5672 7.17214Z",
    fill: "#FBC942"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.567 7.29081H10.3301V7.05347H10.567V7.29081Z",
    fill: "#BD9B37"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8042 6.46022H11.0412H10.8042V6.34155V6.46022Z",
    fill: "#FBC942"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9228 6.46012H10.5674V6.22278H10.9228V6.46012Z",
    fill: "#BD9B37"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9751 7.76556L10.0936 7.88423H9.9751V7.76556Z",
    fill: "#FBC942"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85676 7.76558H9.97524H9.85676L9.73828 7.64691L9.85676 7.76558Z",
    fill: "#FBC942"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M9.97524 7.88425H9.73828V7.64691V7.88425H9.85676H9.97524Z",
    fill: "#BD9B37"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61959 8.00281H9.85655H9.61959C9.61959 8.00281 9.38264 8.12147 9.26416 8.00281C9.26416 8.00281 9.26416 8.00281 9.38264 8.00281H9.61959Z",
    fill: "#9BA068"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73832 7.88414C9.73832 7.88414 9.50136 7.88413 9.38289 8.0028C9.26441 8.0028 9.14593 8.0028 9.14593 8.0028H9.61984V7.76547C9.61984 7.76547 9.38289 7.76548 9.38289 7.88414H9.02745C9.02745 7.88414 8.55354 7.88414 8.43506 8.12147H8.67202C8.67202 8.12147 9.02745 8.0028 9.14593 8.12147H9.26441C9.26441 8.12147 9.38289 8.24014 9.50137 8.12147C9.50137 8.12147 9.73832 8.12147 9.8568 8.12147L9.73832 7.88414Z",
    fill: "#9BA068"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0415 6.69748C11.0415 6.69748 11.0415 6.81615 10.923 6.93482C10.8045 7.05348 10.923 7.17215 10.686 7.17215L10.923 6.93482L11.0415 6.81615V6.69748Z",
    fill: "#9BA068"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9228 6.46016V6.22282C10.9228 6.22282 10.9228 5.98549 10.8043 5.86682C10.8043 5.86682 10.8043 5.86682 10.8043 5.98549C10.8043 5.98549 10.8043 5.98548 10.8043 6.10415C10.8043 6.10415 10.8043 6.10415 10.8043 6.34149V6.57881C10.8043 6.57881 10.6858 7.05348 10.5673 7.05348C10.5673 7.05348 10.5673 6.81615 10.6858 6.69748C10.6858 6.69748 10.5673 6.69749 10.5673 6.81615C10.5673 6.81615 10.5673 6.93481 10.5673 7.05348L10.2119 7.40949C10.2119 7.40949 10.2119 7.40949 10.3304 7.29082C10.3304 7.29082 10.3304 7.17215 10.3304 7.05348V7.17215C10.3304 7.17215 10.3304 7.17215 10.2119 7.29082V7.52815C10.2119 7.52815 10.4489 7.52816 10.4489 7.40949L10.6858 7.17215V6.93482H10.8043C10.8043 6.93482 10.9228 6.69748 11.0413 6.57881C11.0413 6.57881 11.0413 6.34148 11.0413 6.22282L10.9228 6.46016Z",
    fill: "#9BA068"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0416 6.22282C11.0416 6.22282 11.0416 6.22282 10.9232 6.34149V6.10415C10.9232 6.10415 10.9232 5.98549 10.9232 5.86682V6.22282V5.86682C10.9232 5.86682 10.9232 5.98548 10.9232 6.10415H10.8047L11.0416 6.22282Z",
    fill: "#9BA068"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5674 7.17216C10.5674 7.17216 10.6859 6.93483 10.8043 6.93483C10.8043 6.93483 10.8043 6.81616 10.9228 6.81616C10.9228 6.81616 10.9228 6.81616 10.8043 6.93483C10.8043 6.93483 10.6859 7.17216 10.5674 7.29083V7.17216Z",
    fill: "#707633"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8043 6.57883C10.8043 6.57883 10.6859 7.05349 10.5674 7.05349C10.5674 7.05349 10.5674 6.81616 10.6859 6.6975L10.8043 6.57883Z",
    fill: "#707633"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5674 7.05349V6.6975L10.8043 6.57883C10.8043 6.57883 10.6859 6.6975 10.6859 6.81617C10.6859 6.81617 10.6859 6.93483 10.6859 7.05349H10.5674Z",
    fill: "#707633"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.97493 7.76548H10.2119L10.4488 7.52814C10.4488 7.52814 10.3304 7.76548 10.2119 7.88415C10.2119 7.88415 9.97492 7.88415 9.85645 7.88415L9.97493 7.76548Z",
    fill: "#707633"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0938 7.40949C10.0938 7.40949 10.2122 7.29082 10.2122 7.17215V7.29082C10.2122 7.29082 10.2122 7.29082 10.0938 7.40949C10.0938 7.40949 10.0938 7.40949 10.0938 7.29082V7.40949Z",
    fill: "#707633"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4492 7.29083L10.0938 7.52816C10.0938 7.52816 10.0938 7.52817 10.2122 7.4095C10.2122 7.4095 10.3307 7.4095 10.4492 7.29083Z",
    fill: "#707633"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73839 7.88416C9.73839 7.88416 9.50143 7.88415 9.38295 8.00281C9.26447 8.00281 9.146 8.00281 9.146 8.00281H9.61991L9.73839 7.88416Z",
    fill: "#707633"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50112 7.76547C9.50112 7.76547 9.26416 7.76548 9.26416 7.88414C9.26416 7.88414 9.38264 7.76547 9.61959 7.76547H9.50112Z",
    fill: "#707633"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60529 7.76552V7.64685V7.76552L7.48682 7.88419V7.76552H7.60529Z",
    fill: "#FBC942"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36816 7.76544H7.48665V7.88411H7.36816V7.76544Z",
    fill: "#FBC942"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 7.88419H7.48696V7.64685V7.88419H7.25Z",
    fill: "#BD9B37"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01301 7.05347H6.89453L7.01301 6.93481V7.05347Z",
    fill: "#FBC942"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89435 7.17214L7.01284 7.05347V7.29081L6.77588 7.17214H6.89435Z",
    fill: "#FBC942"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7762 7.17215V7.29082L6.65771 7.17215H6.7762Z",
    fill: "#FBC942"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M6.65754 7.17214H6.89449V6.93481V7.17214H6.53906H6.65754Z",
    fill: "#BD9B37"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M6.65705 6.46013L6.53857 6.34146H6.65705V6.46013Z",
    fill: "#FBC942"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M6.53889 6.46014H6.65737L6.53889 6.5788L6.42041 6.46014H6.53889Z",
    fill: "#FBC942"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42023 6.34146L6.30176 6.46013V6.34146H6.42023Z",
    fill: "#FBC942"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42023 6.34146V6.46013H6.30176L6.42023 6.34146Z",
    fill: "#FBC942"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90825 8.00281H8.55281H8.19738H8.07889V8.24015H7.96042V8.00281H7.72346C7.72346 8.00281 7.72346 8.00281 7.60498 8.00281C7.60498 8.00281 7.60498 8.00281 7.72346 8.00281H8.55281C8.55281 8.00281 8.78976 8.00281 9.02672 8.12148H8.90825V8.00281Z",
    fill: "#9BA068"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0127 7.17215H7.13117V7.40949H7.24965V7.52815H7.36813C7.36813 7.52815 7.36813 7.40949 7.36813 7.29082V7.40949V7.17215H7.24965H7.0127Z",
    fill: "#707633"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60491 7.76546H7.48644V7.52812C7.48644 7.52812 7.48644 7.40946 7.48644 7.29079V7.40946V7.17212H7.24948V6.9348H7.01252V6.69746C7.01252 6.69746 7.01252 6.69746 6.89404 6.69746V6.46013C6.89404 6.46013 6.89404 6.46013 6.89404 6.34146V6.10412V5.86679V5.62946V5.86679V6.10412V6.34146V6.57879V6.81613H7.01252C7.01252 6.81613 7.131 7.05345 7.24948 7.05345V7.29079H7.48644H7.96035V7.52812H8.07883L7.60491 7.76546Z",
    fill: "#9BA068"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89418 6.81615C6.89418 6.81615 6.89418 6.81615 6.89418 6.93482H6.77571V6.69748C6.77571 6.69748 6.77571 6.69748 6.65723 6.69748H7.01266L6.89418 6.81615Z",
    fill: "#707633"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30176 6.10412H6.42023V5.86679H6.65719C6.65719 5.86679 6.65719 5.86679 6.53871 5.86679V6.10412V6.34146V6.10412H6.42023H6.30176Z",
    fill: "#707633"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90852 8.2401C8.90852 8.2401 8.90852 8.2401 8.79004 8.12143C8.79004 8.12143 8.90852 8.12143 8.90852 8.2401Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79018 7.88409V8.12142L8.55322 8.35876L8.79018 8.12142V7.88409Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79004 8.12143L8.90852 8.2401H8.79004V8.12143Z",
    fill: "#006748"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M8.67153 7.88409V8.12142C8.67153 8.12142 8.55305 8.12143 8.43457 8.35876L8.67153 8.12142V7.88409Z",
    fill: "#006748"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02682 8.24011C9.02682 8.24011 9.02682 8.12144 8.90834 8.00277V8.24011H8.67139C8.67139 8.24011 8.67139 8.12144 8.90834 8.00277V7.76544V8.00277C8.90834 8.00277 9.02682 8.00277 9.1453 8.24011H9.02682Z",
    fill: "#CC2029"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36816 7.05345C7.36816 7.05345 7.60512 7.17212 7.60512 7.29078C7.60512 7.29078 7.60512 7.29078 7.7236 7.29078C7.84208 7.29078 7.96056 7.29078 7.96056 7.29078H8.31599C8.31599 7.29078 8.67143 7.29078 8.78991 7.29078C8.90838 7.29078 9.02686 7.29078 9.14534 7.17211H9.50078H9.3823C9.3823 7.17211 9.3823 7.17211 9.50078 7.05345C9.50078 7.05345 9.26382 7.05345 9.14534 7.05345C9.02686 7.05345 8.31599 7.05345 8.19752 7.05345C8.07904 7.05345 7.96056 6.81612 7.96056 6.81612C7.96056 6.81612 7.96056 7.05345 7.96056 6.93479L7.48665 6.69745L7.36816 7.05345Z",
    fill: "#30C1DB"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48665 7.05344V6.93478H7.36816V7.05344H7.48665Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72377 7.29077L7.60529 7.40944H7.48682L7.60529 7.29077H7.72377Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07892 7.05344L7.96045 7.17211V7.05344H8.07892Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96077 7.52811V7.64678H7.84229V7.52811H7.96077Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50081 7.52811H9.38232L9.50081 7.64678L9.61928 7.52811H9.50081Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50098 7.64678V7.40945H9.61945V7.64678H9.50098Z",
    fill: "#0C72A6"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73762 7.2908H9.61914V7.40947L9.73762 7.2908Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02734 7.64679C9.02734 7.64679 9.02734 7.64679 9.02734 7.40946V7.17212H9.38278V7.40946V7.64679H9.26431H9.02734Z",
    fill: "#F8A952"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M8.31623 7.64679V7.40946V7.17212H8.55319V7.40946C8.55319 7.40946 8.55319 7.52812 8.55319 7.64679H8.19775H8.31623Z",
    fill: "#F8A952"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79032 7.64679C8.79032 7.64679 8.79032 7.52812 8.79032 7.40946V7.17212V7.40946C8.79032 7.40946 8.79032 7.52812 8.79032 7.64679ZM8.79032 7.40946C8.79032 7.40946 8.79032 7.52812 8.79032 7.64679C8.79032 7.64679 8.79032 7.52812 8.79032 7.40946V7.17212V7.40946ZM8.79032 7.40946C8.79032 7.40946 8.79032 7.64679 8.79032 7.76545H9.02728V7.52812V7.29079H8.67184L8.79032 7.40946ZM8.31641 7.88412H8.67184C8.67184 7.88412 8.67184 7.88412 8.67184 7.76545V7.52812H8.43489V7.76545V8.00278L8.31641 7.88412ZM8.31641 7.40946H9.26424V7.64679V7.76545H8.43489V7.52812L8.31641 7.40946Z",
    fill: "#943120"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13135 6.57877L7.24983 6.46011L7.13135 6.57877Z",
    fill: "#231F20"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60529 6.81612H7.48682L7.60529 6.69745V6.81612Z",
    fill: "#231F20"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M8.31641 6.57877L8.43489 6.46011V6.57877H8.31641Z",
    fill: "#231F20"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19758 6.93477H8.0791V6.8161L8.19758 6.93477Z",
    fill: "#231F20"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43489 7.05344H8.31641V6.93478L8.43489 7.05344Z",
    fill: "#231F20"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55322 6.93478L8.6717 7.05344L8.55322 6.93478Z",
    fill: "#231F20"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38264 7.05344L9.26416 6.93478L9.38264 7.05344Z",
    fill: "#231F20"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50081 7.05344V7.17211L9.38232 7.05344H9.50081Z",
    fill: "#231F20"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73779 7.05344L9.85627 7.17211L9.73779 7.05344Z",
    fill: "#231F20"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73779 6.69747L9.85627 6.5788L9.73779 6.69747Z",
    fill: "#231F20"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50098 6.93477V6.8161L9.61945 6.93477H9.50098Z",
    fill: "#231F20"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26416 6.69747L9.38264 6.5788V6.69747H9.26416Z",
    fill: "#231F20"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96094 6.57877L8.07941 6.46011L7.96094 6.57877Z",
    fill: "#231F20"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84211 6.8161L7.72363 6.93477L7.84211 6.8161Z",
    fill: "#231F20"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38295 6.93479H9.73839C9.73839 6.93479 9.73839 6.81612 9.73839 6.69745C9.73839 6.69745 9.73839 6.69745 9.85687 6.69745C9.85687 6.69745 9.85687 6.81612 9.85687 6.93479C9.85687 6.93479 9.73839 7.05345 9.61991 7.05345C9.61991 7.05345 9.50143 7.05345 9.38295 7.05345H9.146L9.38295 6.93479Z",
    fill: "#0B8388"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M8.67188 7.2908V7.05346H9.02731V6.81613H9.26427V7.05346H9.14579H9.02731C9.02731 7.05346 9.02731 7.05346 9.02731 7.17213H8.79035L8.67188 7.2908Z",
    fill: "#0B8388"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79014 6.81614C8.79014 6.81614 8.79014 6.81614 8.55319 6.9348C8.43471 6.9348 8.31623 6.9348 8.19775 6.9348C8.19775 6.9348 8.19775 6.9348 8.19775 6.81614C8.19775 6.81614 8.19775 6.5788 8.31623 6.5788C8.31623 6.5788 8.31623 6.5788 8.55319 6.5788H8.79014V6.81614Z",
    fill: "#0B8388"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07938 6.69747H7.84243C7.84243 6.69747 7.60547 6.81614 7.60547 6.69747V6.46014H7.84243C7.84243 6.46014 7.9609 6.46014 8.07938 6.46014V6.69747Z",
    fill: "#0B8388"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36862 6.34146V6.57879H7.25014C7.25014 6.57879 7.01318 6.57879 7.01318 6.34146H7.13166C7.13166 6.34146 7.25014 6.34146 7.36862 6.34146Z",
    fill: "#0B8388"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50146 6.93478C9.50146 6.93478 9.50146 6.93478 9.61994 6.93478H9.97538C9.97538 6.93478 9.97538 6.93478 9.8569 6.93478C9.8569 6.93478 9.8569 6.93478 9.8569 7.05344H9.61994L9.50146 6.93478Z",
    fill: "#8BBDBE"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02717 6.81613V7.05346H8.90869C8.90869 7.05346 8.90869 6.9348 8.90869 6.81613H9.02717Z",
    fill: "#8BBDBE"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19775 6.69745H8.31623C8.31623 6.69745 8.31623 6.69745 8.55319 6.69745H8.90862V6.93479H8.55319C8.55319 6.93479 8.43471 6.69745 8.31623 6.69745H8.19775Z",
    fill: "#8BBDBE"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48696 6.34146V6.57879C7.48696 6.57879 7.48696 6.46013 7.48696 6.34146C7.48696 6.34146 7.48696 6.34146 7.25 6.34146C7.25 6.34146 7.48696 6.34146 7.48696 6.46013V6.34146Z",
    fill: "#8BBDBE"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50141 7.05345H9.61989C9.61989 7.05345 9.61989 7.05345 9.85684 7.05345C9.85684 7.05345 10.0938 7.05346 10.0938 6.9348C10.0938 6.9348 10.0938 6.93479 10.0938 6.81613H9.73837C9.73837 6.81613 9.73836 6.9348 9.61989 6.9348L9.50141 7.05345ZM8.79053 7.29079H9.02749C9.02749 7.29079 9.02749 7.29079 9.14597 7.29079H9.38293V7.05345C9.38293 7.05345 9.26445 6.93479 9.14597 7.05345C9.14597 7.05345 9.14597 7.05345 9.02749 7.05345H8.90902C8.90902 7.05345 8.90902 7.05346 8.90902 7.17212L8.79053 7.29079ZM8.19814 6.9348V7.17212C8.19814 7.17212 8.4351 7.17212 8.55358 7.17212C8.55358 7.17212 8.67206 7.17212 8.79053 7.05345H8.67206V6.81613C8.67206 6.81613 8.4351 6.81613 8.31662 6.81613H8.07966L8.19814 6.9348ZM7.60575 6.9348V7.17212C7.60575 7.17212 7.84271 7.17212 7.96119 7.17212H8.19814V6.9348H8.07966C8.07966 6.9348 8.07967 6.81612 7.96119 6.69746C7.96119 6.69746 7.96119 6.69746 7.84271 6.69746L7.60575 6.9348ZM7.60575 6.81613H7.72423H7.84271H7.96119H8.31662C8.31662 6.81613 8.55358 6.81613 8.67206 6.81613H9.14597C9.14597 6.81613 9.26445 6.81613 9.38293 6.81613C9.38293 6.81613 9.50141 6.93479 9.50141 7.05345H9.73837V6.81613H9.97532C9.97532 6.81613 9.97532 6.93479 9.97532 7.05345C9.97532 7.05345 9.85685 7.17212 9.73837 7.17212H8.90902C8.90902 7.17212 8.90902 7.17213 8.90902 7.29079H8.67206V7.05345C8.67206 7.05345 8.4351 7.05345 8.31662 7.05345C8.31662 7.05345 8.19814 7.05345 8.07966 7.05345C8.07966 7.05345 8.07966 7.05346 8.07966 6.9348H7.84271H7.60575H7.36879C7.36879 6.9348 7.13184 6.69746 7.13184 6.57879C7.13184 6.57879 7.13184 6.46013 7.13184 6.34146C7.13184 6.34146 7.36879 6.46012 7.36879 6.57879L7.60575 6.81613ZM7.60575 6.9348C7.60575 6.9348 7.48727 6.57879 7.36879 6.57879H7.25032V6.81613L7.48727 7.05345H7.72423L7.60575 6.9348Z",
    fill: "#05534E"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84229 6.69745L7.96077 6.81612H7.84229V6.69745Z",
    fill: "#05534E"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72395 6.69745V6.81612L7.60547 6.69745H7.72395Z",
    fill: "#05534E"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72363 6.5788V6.69747H7.84211L7.72363 6.5788Z",
    fill: "#231F20"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85627 7.05344H9.73779V6.93478L9.85627 7.05344Z",
    fill: "#05534E"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85627 7.05344H9.73779V6.93478L9.85627 7.05344Z",
    fill: "#8BBDBE"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85627 6.93478L9.73779 7.05344H9.85627V6.93478Z",
    fill: "#231F20"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50098 6.93478V7.05344H9.61945V6.93478H9.50098Z",
    fill: "#05534E"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50098 6.93478V7.05344H9.61945V6.93478H9.50098Z",
    fill: "#8BBDBE"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M8.31623 6.81612H8.19775L8.31623 6.69745V6.81612Z",
    fill: "#05534E"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M8.31623 6.69745L8.19775 6.81612L8.31623 6.69745Z",
    fill: "#8BBDBE"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19775 6.69745V6.81612L8.31623 6.69745H8.19775Z",
    fill: "#231F20"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72395 6.5788L7.60547 6.69747V6.5788H7.72395Z",
    fill: "#05534E"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24983 6.34145H7.13135L7.24983 6.22278V6.34145Z",
    fill: "#05534E"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24983 6.34145H7.13135L7.24983 6.22278V6.34145Z",
    fill: "#8BBDBE"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24983 6.46013H7.13135V6.34146H7.24983V6.46013Z",
    fill: "#05534E"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24983 6.46013H7.13135V6.34146H7.24983V6.46013Z",
    fill: "#8BBDBE"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36848 6.34146L7.25 6.46013V6.34146H7.36848Z",
    fill: "#05534E"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36848 6.34146L7.25 6.46013V6.34146H7.36848Z",
    fill: "#8BBDBE"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36848 6.34145H7.25V6.22278H7.36848V6.34145Z",
    fill: "#05534E"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36848 6.34145H7.25V6.22278H7.36848V6.34145Z",
    fill: "#8BBDBE"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48665 6.46013H7.36816V6.34146H7.48665V6.46013Z",
    fill: "#05534E"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36848 6.57877H7.25V6.46011H7.36848V6.57877Z",
    fill: "#05534E"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36848 6.57877H7.25V6.46011H7.36848V6.57877Z",
    fill: "#8BBDBE"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13135 6.22278V6.34145L7.24983 6.22278H7.13135Z",
    fill: "#231F20"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13135 6.34146V6.46013L7.24983 6.34146H7.13135Z",
    fill: "#231F20"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 6.22278L7.36848 6.34145L7.25 6.22278Z",
    fill: "#231F20"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02686 7.05344V6.93478H9.14534H9.02686V7.05344Z",
    fill: "#05534E"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90852 7.17211H8.79004V7.05344H8.90852V7.17211Z",
    fill: "#05534E"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90852 7.17211H8.79004V7.05344H8.90852V7.17211Z",
    fill: "#8BBDBE"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14551 7.05344V6.93478H9.26399V7.05344H9.14551Z",
    fill: "#05534E"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14551 7.05344V6.93478H9.26399V7.05344H9.14551Z",
    fill: "#8BBDBE"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26399 6.93478H9.14551L9.26399 7.05344V6.93478Z",
    fill: "#231F20"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26416 6.93477V6.8161H9.38264L9.26416 6.93477Z",
    fill: "#05534E"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26416 6.93477V6.8161H9.38264L9.26416 6.93477Z",
    fill: "#8BBDBE"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96077 6.34146L7.84229 6.46013V6.34146H7.96077Z",
    fill: "url(#paint0_radial_1182_79154)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01301 5.86679V5.98546H6.89453L7.01301 5.86679Z",
    fill: "url(#paint1_radial_1182_79154)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13166 6.10413V6.2228C7.13166 6.2228 7.13166 6.2228 7.01318 6.2228V6.10413C7.01318 6.10413 7.01318 6.10413 7.13166 6.10413Z",
    fill: "url(#paint2_radial_1182_79154)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0936 6.81612H9.9751C9.9751 6.81612 9.9751 6.81612 9.9751 6.69745H10.0936C10.0936 6.69745 10.0936 6.69745 10.0936 6.81612Z",
    fill: "url(#paint3_radial_1182_79154)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2117 6.69747H10.0933V6.5788H10.2117V6.69747Z",
    fill: "url(#paint4_radial_1182_79154)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60529 6.10413V6.2228H7.48682V6.10413H7.60529Z",
    fill: "#77722F"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60547 5.98547H7.72395V6.10413H7.60547V5.98547Z",
    fill: "#77722F"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48682 5.98549L7.60529 5.86682V5.98549H7.48682Z",
    fill: "#77722F"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36816 6.10413V5.98547H7.48665V6.10413H7.36816Z",
    fill: "#77722F"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36816 5.98549V5.86682H7.48665L7.36816 5.98549Z",
    fill: "#77722F"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60529 5.62939V5.74806L7.48682 5.62939H7.60529Z",
    fill: "#77722F"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48682 5.51078V5.27344V5.39211H7.60529L7.48682 5.51078Z",
    fill: "#77722F"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60547 5.39211V5.27344H7.72395L7.60547 5.39211Z",
    fill: "#77722F"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48682 5.27345L7.60529 5.15479V5.27345H7.48682Z",
    fill: "#77722F"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60547 5.03613H7.72395V5.1548H7.60547V5.03613Z",
    fill: "#77722F"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72363 5.27345V5.15479H7.84211L7.72363 5.27345Z",
    fill: "#77722F"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84229 5.1548V5.03613H7.96077L7.84229 5.1548Z",
    fill: "#77722F"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96077 5.03614H7.84229L7.96077 4.91748H8.07924L7.96077 5.03614Z",
    fill: "#77722F"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84229 4.79883L7.96077 4.9175L7.84229 4.79883Z",
    fill: "#77722F"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84229 4.9175V4.79883V4.9175H7.96077H7.84229Z",
    fill: "#77722F"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60529 4.68005L7.72377 4.79872H7.60529H7.48682L7.60529 4.68005Z",
    fill: "#77722F"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60547 6.2228V6.10413H7.72395V6.2228H7.60547Z",
    fill: "#A7AB71"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60529 5.98547L7.48682 6.10413V5.98547H7.60529Z",
    fill: "#A7AB71"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36816 5.98549L7.48665 5.86682H7.60512L7.48665 5.98549H7.36816Z",
    fill: "#A7AB71"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48665 5.86684H7.36816V5.74817H7.48665V5.86684Z",
    fill: "#A7AB71"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48682 5.51086L7.60529 5.62952H7.48682V5.51086Z",
    fill: "#A7AB71"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48682 5.51088L7.60529 5.39221V5.51088H7.48682Z",
    fill: "#A7AB71"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60547 5.27345V5.15479V5.27345H7.72395H7.60547Z",
    fill: "#A7AB71"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72395 5.15479H7.60547H7.72395V5.27345V5.15479Z",
    fill: "#A7AB71"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72363 5.03613H7.84211V5.1548H7.72363V5.03613Z",
    fill: "#A7AB71"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60547 4.68005H7.84243V4.91739C7.84243 4.91739 7.84243 4.91739 7.72395 4.91739L7.60547 4.68005Z",
    fill: "#A7AB71"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48682 4.79872V4.68005H7.60529L7.48682 4.79872Z",
    fill: "#A7AB71"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48665 4.79886L7.36816 4.68019L7.48665 4.56152V4.68019V4.79886Z",
    fill: "#A7AB71"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60543 4.44278V4.20544C7.60543 4.20544 7.60544 4.20544 7.48696 4.20544V4.44278H7.60543H7.72391H7.60543ZM7.36848 4.44278C7.36848 4.44278 7.36848 4.20545 7.36848 4.32411H7.25L7.36848 4.44278Z",
    fill: "#A7AB71"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96094 5.74806L8.07941 5.62939V5.74806H7.96094Z",
    fill: "#F8C73E"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96094 4.9175V4.79883H8.07941V4.9175H7.96094Z",
    fill: "#F8C73E"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96094 4.79872V4.68005L8.07941 4.79872H7.96094V4.91739V4.79872Z",
    fill: "#F8C73E"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07941 5.86684H7.96094L8.07941 5.74817V5.86684Z",
    fill: "#AE6F2A"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96094 5.86684H8.07941V5.74817L8.19789 5.86684H7.96094Z",
    fill: "#AE6F2A"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96094 5.74806V5.62939H8.07941L7.96094 5.74806Z",
    fill: "#F8C73E"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84229 4.79872L7.96077 4.68005V4.79872H7.84229Z",
    fill: "#F8C73E"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96077 5.74806H7.84229V5.62939H7.96077V5.74806Z",
    fill: "#F8C73E"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96077 4.91748L7.84229 5.03614V4.91748H7.96077Z",
    fill: "white"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84229 4.9175V4.79883L7.96077 4.9175H7.84229Z",
    fill: "white"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84229 4.79872V4.68005H7.96077L7.84229 4.79872Z",
    fill: "#F8C73E"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84211 5.74806L7.72363 5.62939H7.84211V5.74806Z",
    fill: "#F8C73E"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84211 4.79872L7.72363 4.68005H7.84211V4.79872Z",
    fill: "#F8C73E"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72363 5.74806V5.62939L7.84211 5.74806H7.72363Z",
    fill: "#AE6F2A"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72363 5.27345L7.84211 5.15479L7.72363 5.27345Z",
    fill: "#949457"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72363 6.22282C7.72363 6.22282 7.84211 5.98549 7.96059 5.86682H8.19755C8.19755 5.86682 8.19754 5.98548 8.07907 6.10415H7.84211L7.72363 6.22282Z",
    fill: "#AE6F2A"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60547 5.74806L7.72395 5.62939V5.74806H7.60547Z",
    fill: "#AE6F2A"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0791 4.91748H8.43454V5.15481V5.39215V5.15481H8.19758V4.91748H8.0791Z",
    fill: "#949457"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72395 5.27345H7.60547V5.15479H7.72395V5.27345Z",
    fill: "white"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60547 4.68019V4.56152L7.72395 4.68019H7.60547Z",
    fill: "#949457"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72395 5.27344L7.60547 5.39211L7.72395 5.27344Z",
    fill: "#AE6F2A"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72395 5.27344L7.60547 5.39211L7.72395 5.27344L7.60547 5.39211L7.72395 5.27344Z",
    fill: "#949457"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60547 5.98547H7.72395H7.60547V6.10413V5.98547Z",
    fill: "white"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60547 5.62952V5.51086V5.62952H7.72395H7.60547Z",
    fill: "#AE6F2A"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60547 4.68005L7.72395 4.79872L7.60547 4.68005Z",
    fill: "white"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60547 5.51086H7.72395V5.62952H7.60547V5.51086Z",
    fill: "#AE6F2A"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84211 5.62939H8.31602V5.86673V6.10406C8.31602 6.10406 8.31603 6.22273 8.19755 6.3414C8.19755 6.3414 8.31602 6.22273 8.31602 6.10406H8.07907C8.07907 6.10406 7.96059 6.10406 7.84211 6.22273H8.07907V5.9854H7.96059V5.74806H7.72363L7.84211 5.62939Z",
    fill: "#949457"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60529 6.10413H7.48682H7.60529V5.98547V6.10413Z",
    fill: "white"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48682 4.68019L7.60529 4.56152V4.68019H7.48682Z",
    fill: "#949457"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48682 5.51086H7.60529V5.62952L7.48682 5.51086Z",
    fill: "white"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60529 6.10413H7.48682L7.60529 5.98547V6.10413Z",
    fill: "white"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60529 4.56152L7.48682 4.68019V4.56152H7.60529Z",
    fill: "#949457"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60529 4.68005L7.48682 4.79872L7.60529 4.68005Z",
    fill: "white"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48682 5.98549L7.60529 5.86682L7.48682 5.98549Z",
    fill: "white"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60529 5.39221L7.48682 5.51088L7.60529 5.39221Z",
    fill: "white"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60529 5.39211H7.48682V5.27344V5.39211H7.60529Z",
    fill: "white"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48682 5.74806H7.60529H7.48682V5.62939L7.60529 5.74806H7.48682Z",
    fill: "#949457"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60529 6.2228H7.48682V6.10413V6.2228H7.60529Z",
    fill: "#949457"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48665 6.10413H7.36816H7.48665V5.98547V6.10413Z",
    fill: "white"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36816 5.98549L7.48665 5.86682L7.36816 5.98549Z",
    fill: "white"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48665 4.56152L7.36816 4.68019L7.48665 4.56152Z",
    fill: "white"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36848 5.74817H7.48696H7.36848V5.86684L7.25 5.74817H7.36848Z",
    fill: "white"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36816 4.68005L7.48665 4.79872L7.36816 4.68005Z",
    fill: "#949457"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72395 4.44278V4.20544C7.72395 4.20544 7.72395 4.20544 7.60547 4.20544V4.44278V4.20544H7.72395V4.44278C7.72395 4.44278 7.72395 4.44278 7.60547 4.44278H7.72395Z",
    fill: "#949457"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 5.74806L7.36848 5.62939V5.74806H7.25Z",
    fill: "#A7AB71"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36848 5.51088H7.25V5.39221L7.36848 5.51088Z",
    fill: "white"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 5.27344H7.36848V5.39211H7.25V5.27344Z",
    fill: "white"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36848 5.62939L7.25 5.74806V5.62939H7.36848Z",
    fill: "white"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36848 5.39221V5.51088L7.25 5.39221H7.36848Z",
    fill: "#A7AB71"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36848 5.27344H7.25V5.39211V5.27344H7.36848Z",
    fill: "#A7AB71"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36848 5.51086V5.62952H7.25V5.51086H7.36848Z",
    fill: "white"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 5.27345V5.15479L7.36848 5.27345H7.25Z",
    fill: "white"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13135 5.27345L7.24983 5.15479V5.27345H7.13135Z",
    fill: "#A7AB71"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24983 5.15479L7.13135 5.27345V5.15479H7.24983Z",
    fill: "white"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13135 5.27345V5.15479H7.24983H7.13135V5.27345Z",
    fill: "#F8C73E"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01318 5.27345V5.15479H7.13166V5.27345H7.01318Z",
    fill: "#F8C73E"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01301 5.15479V5.27345V5.15479H6.89453H7.01301Z",
    fill: "#F8C73E"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48696 5.86679V5.62945V5.39212H7.25V5.15479H7.60543V5.39212V5.62945V5.39212V5.15479V5.39212V5.62945V5.86679H7.48696Z",
    fill: "#949457"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M10.449 5.15479C10.449 5.15479 10.449 5.39212 10.449 5.62945C10.449 5.62945 10.449 5.98545 10.449 6.10412C10.449 6.10412 10.449 5.98546 10.449 5.86679V5.51079V5.15479H10.686H10.449ZM10.449 5.86679C10.449 5.86679 10.449 5.62946 10.449 5.51079C10.449 5.27346 10.3306 5.27345 10.3306 5.27345C10.3306 5.27345 10.3306 5.39213 10.3306 5.51079C10.3306 5.51079 10.3306 5.74812 10.3306 5.86679H10.449Z",
    fill: "#4C2915"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5673 5.15479H10.3304V4.7988H10.2119V4.56146H9.97493V4.32413H9.85645V4.08679C9.85645 4.08679 10.0934 4.20546 10.2119 4.32413C10.3304 4.4428 10.4488 4.56146 10.4488 4.7988C10.4488 5.03613 10.5673 5.03612 10.6858 5.03612L10.5673 5.15479Z",
    fill: "#8E4520"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4487 5.39211C10.4487 5.39211 10.4487 5.62944 10.4487 5.7481C10.4487 5.62944 10.4487 5.39211 10.4487 5.39211C10.4487 5.39211 10.4487 5.3921 10.4487 5.27344C10.4487 5.27344 10.5672 5.27344 10.5672 5.39211H10.4487Z",
    fill: "#8E4520"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2117 5.15479C10.2117 5.15479 10.2117 5.39213 10.2117 5.51079L10.0933 5.15479H10.2117Z",
    fill: "#AA6C2A"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2117 5.51079C10.2117 5.51079 10.0933 5.39212 10.0933 5.15479C10.0933 5.15479 10.2117 5.39213 10.2117 5.51079Z",
    fill: "#D1A467"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2117 5.62945C10.2117 5.62945 10.2117 5.86679 10.2117 5.98546C10.2117 5.98546 10.2117 5.74813 10.2117 5.51079C10.2117 5.51079 10.2117 5.27345 10.0933 5.15479C10.0933 5.15479 10.0933 5.39213 10.2117 5.51079V5.62945Z",
    fill: "#4C2915"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2117 5.62945L10.0933 5.15479C10.0933 5.15479 10.0933 5.39213 10.2117 5.51079C10.2117 5.51079 10.2117 5.62945 10.2117 5.74812V5.62945Z",
    fill: "#231F20"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2117 5.0361C10.2117 5.0361 10.2117 4.91744 10.2117 4.79878C10.2117 4.79878 10.2117 4.44278 10.0933 4.44278C10.0933 4.44278 10.3302 4.68011 10.4487 4.79878V5.0361H10.2117Z",
    fill: "#4C2915"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2117 5.51078C10.2117 5.51078 10.2117 5.86678 10.2117 5.98545V5.51078H10.0933V5.27344V5.0361H10.2117C10.2117 5.0361 10.2117 5.39211 10.3302 5.51078H10.2117Z",
    fill: "#8E4520"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2117 4.79878L10.0933 4.68011L10.2117 4.79878Z",
    fill: "#D1A467"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2117 4.79879C10.2117 4.79879 9.97475 4.56146 9.85627 4.4428C9.85627 4.4428 9.85627 4.56146 9.97475 4.68012L9.73779 4.32413H9.97475V4.56145H10.2117V4.79879H10.3302H10.2117Z",
    fill: "#231F20"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0935 6.34146C10.0935 6.34146 9.97503 6.46012 9.85655 6.34146H9.73807C9.73807 6.34146 9.38264 5.98546 9.26416 5.86679H9.50112L9.73807 6.22279H10.0935V6.34146Z",
    fill: "#231F20"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0934 4.79877C10.0934 4.79877 10.0934 4.91743 10.0934 5.03609H9.85645H9.97493C9.97493 5.03609 9.97493 5.0361 9.97493 4.79877H10.0934Z",
    fill: "#D1A467"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0936 5.74811V6.1041C10.0936 6.1041 10.0936 5.51078 10.0936 5.39211C10.0936 5.39211 9.9751 5.15477 9.9751 5.0361C9.9751 5.0361 9.9751 5.15477 9.9751 5.27344V5.74811H10.0936Z",
    fill: "#231F20"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0932 6.34144H9.73776V6.1041H9.61928L9.38232 5.86678L9.61928 6.1041H9.38232C9.38232 6.1041 9.38232 5.86677 9.38232 5.74811C9.38232 5.74811 9.85624 6.10411 9.97472 6.22277H10.0932V6.34144Z",
    fill: "#4C2915"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0936 5.51078C10.0936 5.51078 10.0936 5.86677 10.0936 6.1041V5.62943C10.0936 5.62943 10.0936 5.62944 10.0936 5.51078C10.0936 5.39211 10.0936 5.27344 9.9751 5.27344C9.9751 5.27344 9.97509 5.51077 10.0936 5.62943V5.51078Z",
    fill: "#4C2915"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0934 4.79879C10.0934 4.79879 10.0934 4.91745 10.0934 5.03612C10.0934 5.03612 10.0934 5.03612 9.97489 5.03612C9.97489 5.03612 9.61946 4.44279 9.50098 4.32413C9.50098 4.32413 9.61945 4.32412 9.73793 4.56145V4.91746L10.0934 4.79879Z",
    fill: "#8E4520"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M9.97493 5.51079C9.97493 5.51079 9.97493 5.74813 9.97493 5.98546C9.97493 5.98546 9.97493 5.86679 9.97493 5.74812C9.97493 5.62945 9.97493 5.51079 9.97493 5.51079C9.97493 5.51079 9.97492 5.27345 9.85645 5.15479C9.85645 5.15479 9.85645 5.15479 9.97493 5.39212C9.97493 5.51079 9.97493 5.51079 9.97493 5.51079Z",
    fill: "#8E4520"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61963 4.32413C9.61963 4.32413 10.0935 4.7988 10.0935 4.91746V4.68012C10.0935 4.68012 9.85659 4.4428 9.73811 4.4428L10.0935 4.79879C10.0935 4.68013 9.73811 4.44279 9.73811 4.32413H9.61963Z",
    fill: "#4C2915"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M9.97489 6.46012H9.73793L9.50098 6.22278H9.73793V6.46012H9.85641H9.97489Z",
    fill: "#4C2915"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M9.97472 6.46013H9.85624V6.22279H9.61928L9.38232 5.86679L9.61928 6.10412H9.73776V6.34146H9.97472V6.46013Z",
    fill: "#AA6C2A"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M9.97472 6.46014H9.73776V6.2228L9.38232 5.98547H9.50081L9.73776 6.34147H9.85624C9.85624 6.34147 9.85624 6.34147 9.97472 6.34147V6.46014Z",
    fill: "#231F20"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M9.97489 4.91747L9.73793 4.7988C9.73793 4.7988 9.50098 4.68013 9.50098 4.56146C9.50098 4.56146 9.61945 4.56147 9.73793 4.7988H9.85641L9.97489 4.91747Z",
    fill: "#8E4520"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85645 4.4428H9.97493L9.85645 4.32413V4.4428Z",
    fill: "#D1A467"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M9.97507 5.7481C9.97507 5.7481 9.97506 5.51078 9.85659 5.51078C9.85659 5.51078 9.73811 5.27344 9.61963 5.27344C9.61963 5.27344 9.73811 5.51078 9.85659 5.51078V5.7481H9.97507Z",
    fill: "#8E4520"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M9.97472 6.46013C9.97472 6.46013 9.97472 6.46013 9.85624 6.46013H9.73776L9.50081 6.10412H9.38232V5.86679L9.61928 6.10412L9.85624 6.34146H9.97472V6.46013Z",
    fill: "#4C2915"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M9.97493 5.62946V5.74812L9.85645 5.62946H9.97493Z",
    fill: "#4C2915"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M9.97493 5.62945C9.97493 5.62945 9.85645 5.27345 9.85645 5.15479C9.85645 5.15479 9.85645 5.27346 9.85645 5.39212V5.62945H9.97493Z",
    fill: "#231F20"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85645 5.51078V5.27344C9.85645 5.27344 9.97493 5.39211 9.97493 5.51078H9.85645Z",
    fill: "#AA6C2A"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85659 5.62943L9.61963 5.27344C9.61963 5.27344 9.61963 5.51078 9.73811 5.51078L9.85659 5.62943Z",
    fill: "#4C2915"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85627 4.91745V5.03611L9.73779 4.91745H9.85627Z",
    fill: "#D1A467"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85655 6.46014H9.73807L9.50112 6.2228L9.26416 5.98547C9.26416 5.98547 9.50112 6.2228 9.73807 6.34147H9.85655V6.46014Z",
    fill: "#8E4520"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85659 5.03611C9.85659 5.03611 9.61963 4.79878 9.61963 4.68011C9.61963 4.68011 9.97507 4.91744 9.97507 5.03611H9.85659Z",
    fill: "#4C2915"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73776 4.91745C9.73776 4.91745 9.5008 4.68011 9.38232 4.68011C9.38232 4.68011 9.5008 4.68011 9.61928 4.68011C9.61928 4.68011 9.61928 4.79878 9.85624 4.79878L9.73776 4.91745Z",
    fill: "#231F20"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85627 5.86677V5.62943C9.85627 5.62943 9.73779 5.3921 9.73779 5.27344H9.97475V5.62943C9.97475 5.62943 9.97475 5.74811 10.0932 5.86677H9.85627Z",
    fill: "#231F20"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M9.97507 4.91745C9.97507 4.91745 9.73811 4.68011 9.61963 4.44278C9.61963 4.44278 9.97507 4.79878 9.97507 4.91745Z",
    fill: "#231F20"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73779 5.62943V5.86677V5.51078V5.27344V5.51078H9.97475L9.73779 5.62943Z",
    fill: "#8E4520"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85652 4.08677H9.61956H9.50109H9.26413L9.14565 3.84944C9.14565 3.84944 9.14565 3.84944 9.26413 3.84944C9.26413 3.84944 9.14565 3.84944 9.02717 3.73077H8.90869C8.90869 3.73077 9.26413 3.73077 9.38261 3.73077L9.61956 3.84944H9.73804L9.85652 4.08677ZM9.61956 4.20544V3.96811V4.20544ZM9.61956 4.20544V3.96811V4.20544Z",
    fill: "#8E4520"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73779 5.51078V5.27344C9.73779 5.27344 9.85627 5.39211 9.97475 5.51078H9.73779Z",
    fill: "#AA6C2A"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73793 4.20546H9.61945H9.50098H9.61945L9.73793 4.08679V4.20546Z",
    fill: "#D1A467"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73793 5.03609C9.73793 5.03609 9.61946 4.91743 9.50098 4.79877C9.50098 4.79877 9.61945 4.91743 9.73793 5.03609Z",
    fill: "#8E4520"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73807 6.46013C9.73807 6.46013 9.73807 6.46013 9.50112 6.46013C9.50112 6.46013 9.26416 6.22279 9.26416 6.10413L9.50112 6.34146H9.73807V6.46013Z",
    fill: "#231F20"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73793 5.03609L9.50098 4.79877C9.50098 4.79877 9.61945 4.91744 9.73793 4.91744V5.03609Z",
    fill: "#4C2915"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73807 6.46014H9.61959L9.38264 6.2228H9.26416V5.98547L9.50112 6.34147H9.61959L9.73807 6.46014Z",
    fill: "#4C2915"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73793 5.51078H9.50098V5.27344C9.50098 5.27344 9.50097 5.51078 9.61945 5.51078H9.73793Z",
    fill: "#4C2915"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73811 5.7481C9.73811 5.7481 9.73811 5.51077 9.61963 5.39211C9.61963 5.39211 9.61963 5.3921 9.61963 5.27344C9.61963 5.27344 9.61963 5.27344 9.73811 5.39211V5.7481Z",
    fill: "#231F20"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61928 5.03609H9.38232V4.79877L9.61928 5.03609Z",
    fill: "#231F20"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61928 6.46012L9.38232 6.22278H9.50081V6.46012H9.61928Z",
    fill: "#8E4520"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61928 5.15478H9.38232C9.38232 5.15478 9.5008 5.15478 9.38232 5.15478V4.91745L9.61928 5.15478Z",
    fill: "#D1A467"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61928 5.74812L9.38232 5.39212C9.38232 5.39212 9.38232 5.39212 9.38232 5.51079C9.38232 5.51079 9.38233 5.62945 9.50081 5.74812H9.61928Z",
    fill: "#8E4520"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61928 5.39212H9.38232V5.15479L9.61928 5.39212Z",
    fill: "#AA6C2A"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38232 5.39212L9.61928 5.74812C9.61928 5.74812 9.50081 5.51079 9.50081 5.39212H9.38232Z",
    fill: "#8E4520"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61963 4.20544V4.44278C9.61963 4.44278 9.61963 4.32411 9.73811 4.32411L9.61963 4.20544Z",
    fill: "#8E4520"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50081 5.39211C9.50081 5.39211 9.38232 5.3921 9.38232 5.27344H9.50081V5.39211Z",
    fill: "#D1A467"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61963 6.46013C9.61963 6.46013 9.61963 6.46013 9.61963 6.34146V6.10413C9.61963 6.10413 9.73811 6.34146 9.85659 6.34146L9.61963 6.46013Z",
    fill: "#4C2915"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50077 4.20544H9.26382H9.38229V4.44278H9.26382V4.56144V4.79878L9.14534 4.68011V4.44278V4.20544C9.14534 4.20544 9.14533 4.20544 9.02686 4.20544C9.02686 4.20544 9.02686 4.20545 9.14534 4.32411H9.38229C9.38229 4.32411 9.3823 4.32412 9.50077 4.44278V4.20544Z",
    fill: "#231F20"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50081 4.56146V4.7988V5.03613H9.38232V5.27347V5.1548H9.50081C9.50081 5.1548 9.50081 5.1548 9.50081 5.03613V4.7988V4.56146Z",
    fill: "#D1A467"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50112 6.57879C9.50112 6.57879 9.38264 6.46013 9.26416 6.34146C9.26416 6.34146 9.26416 6.46012 9.26416 6.57879H9.50112Z",
    fill: "#231F20"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50095 6.57879C9.50095 6.57879 9.50094 6.69746 9.38246 6.57879C9.38246 6.57879 9.26399 6.57879 9.14551 6.57879V6.34146V6.57879H9.38246H9.50095Z",
    fill: "#F8C73E"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38232 4.0868V3.96814H9.50081L9.38232 4.0868Z",
    fill: "#D1A467"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38264 6.5788V6.69747H9.26416V6.5788H9.38264Z",
    fill: "#F8C73E"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38264 5.0361V5.15477H9.26416V5.0361H9.38264Z",
    fill: "#8E4520"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38264 5.27345V5.39212H9.26416V5.27345V5.15479L9.38264 5.27345Z",
    fill: "#8E4520"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38264 4.68011V4.79878L9.26416 4.91745V4.79878V4.91745V4.79878V4.68011H9.38264Z",
    fill: "#4C2915"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26382 5.15477L9.38229 5.27344L9.26382 5.15477H9.14534V5.27344H9.02686L9.14534 5.15477V5.0361H9.26382V5.15477Z",
    fill: "#231F20"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26413 5.62946C9.26413 5.62946 9.26413 5.8668 9.26413 5.98546H8.90869V5.74812C8.90869 5.74812 9.02717 5.98546 9.14565 6.10412V5.86679V5.98546C9.14565 5.98546 9.14565 5.98546 9.14565 5.86679V5.62946C9.14565 5.62946 9.14565 5.8668 9.14565 5.98546C9.14565 5.98546 9.14565 5.74812 9.14565 5.62946H9.26413Z",
    fill: "#8E4520"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26396 4.56146V4.7988H9.14548V4.91747V5.1548H9.027V4.91747C9.027 4.91747 9.027 4.91747 9.14548 4.7988C9.14548 4.7988 9.14548 4.56147 9.14548 4.44281V4.20547H8.79004V3.96814C8.79004 3.96814 8.79004 3.96814 8.90852 3.96814V4.20547C8.90852 4.20547 9.027 4.20547 9.14548 4.20547V4.44281V4.68013C9.14548 4.68013 9.14548 4.68013 9.26396 4.68013V4.56146Z",
    fill: "#8E4520"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26399 6.57877H9.14551V6.46011H9.26399V6.57877Z",
    fill: "#F8C73E"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26399 4.91744V5.03609H9.14551H9.26399L9.14551 4.91744V4.79877L9.26399 4.91744Z",
    fill: "#4C2915"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26399 5.27345V5.39212H9.14551V5.27345V5.15479H9.26399V5.27345Z",
    fill: "#AA6C2A"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14551 6.46011V6.69744V6.46011H9.26399H9.14551Z",
    fill: "#BD9B37"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14534 6.57877H9.02686V6.46011L9.14534 6.57877Z",
    fill: "#F8C73E"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14534 6.57879H9.02686V6.34146C9.02686 6.34146 9.02686 6.34146 9.02686 6.46013V6.69746L9.14534 6.57879Z",
    fill: "#4C2915"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14534 5.03611L9.02686 5.15478V5.03611V4.91745V5.03611L9.14534 4.91745V5.03611Z",
    fill: "#4C2915"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14565 5.39212C9.14565 5.39212 9.14565 5.51078 9.14565 5.62945C9.14565 5.62945 9.14565 5.62945 9.14565 5.74812H8.90869V5.51079L9.14565 5.74812V5.51079H9.26413C9.26413 5.51079 9.26413 5.51079 9.26413 5.39212H9.14565Z",
    fill: "#DAAC6D"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14551 6.34145V6.22278H9.26399L9.14551 6.34145Z",
    fill: "#231F20"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02686 6.5788H9.14534L9.02686 6.69747V6.5788Z",
    fill: "#F8C73E"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02717 5.27344V5.51078C9.02717 5.51078 9.02717 5.27344 8.90869 5.27344V5.51078C8.90869 5.51078 9.02717 5.3921 9.02717 5.27344Z",
    fill: "#8E4520"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02728 6.22278H8.79032C8.79032 6.22278 8.67184 5.98545 8.67184 5.86679C8.55337 5.86679 8.31641 5.51079 8.31641 5.39212C8.31641 5.39212 8.43488 5.74812 8.55336 5.74812C8.55336 5.74812 8.55336 5.98545 8.79032 6.10411C8.79032 6.10411 8.67184 5.98545 8.67184 5.86679V6.10411H8.9088C8.9088 6.10411 8.9088 6.22278 8.9088 6.10411L9.02728 6.22278Z",
    fill: "#8E4520"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02717 4.44278C9.02717 4.44278 9.02717 4.68011 9.02717 4.79878C9.02717 4.79878 9.02717 4.91745 8.90869 4.91745V4.68011V4.44278V4.20544V4.44278H9.02717Z",
    fill: "#D1A467"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90852 5.74811C8.90852 5.74811 9.027 5.98544 9.027 6.1041C9.027 6.1041 8.90852 5.86677 8.79004 5.74811H8.90852Z",
    fill: "#4C2915"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02717 6.69747H8.90869V6.5788H9.02717V6.69747Z",
    fill: "#F8C73E"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M9.027 4.56145V4.68012V4.44279V4.20545V4.08678H8.90852H8.79004V3.84946V3.96813H9.14548V4.20545V4.44279C9.14548 4.44279 9.14548 4.44278 9.14548 4.56145H9.027Z",
    fill: "#AA6C2A"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02717 5.98545L8.90869 5.74811H9.02717V5.98545Z",
    fill: "#231F20"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02717 5.51079C9.02717 5.51079 9.02717 5.39212 8.90869 5.39212C8.90869 5.39212 8.90869 5.39212 8.90869 5.51079H9.02717Z",
    fill: "#231F20"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90883 5.62945L8.67188 5.39212C8.67188 5.39212 8.67187 5.51078 8.79035 5.62945H8.90883Z",
    fill: "#8E4520"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90852 6.1041H8.79004V5.74811C8.79004 5.74811 8.79004 5.98544 8.90852 6.1041Z",
    fill: "#4C2915"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90866 5.62945H8.55322V5.39212C8.55322 5.39212 8.6717 5.62945 8.79018 5.74812V5.51079L8.90866 5.62945Z",
    fill: "#DAAC6D"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90869 5.27344C8.90869 5.27344 8.90869 5.39211 9.02717 5.51078V5.27344H8.90869Z",
    fill: "#4C2915"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90852 6.81612V6.93479L8.79004 6.81612L8.90852 6.69745V6.81612Z",
    fill: "#231F20"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90852 5.51079C8.90852 5.51079 8.79004 5.51079 8.79004 5.39212H8.90852V5.51079Z",
    fill: "#4C2915"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90869 5.03611C8.90869 5.03611 8.90869 4.79878 8.90869 4.68011V4.91745H9.02717L8.90869 5.03611Z",
    fill: "#4C2915"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90852 4.20544H8.79004H9.14548C9.14548 4.20544 9.14548 4.20545 9.26396 4.32411L8.90852 4.20544Z",
    fill: "#4C2915"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90852 6.5788V6.69747H8.79004V6.5788H8.90852Z",
    fill: "#F8C73E"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90852 5.03611H8.79004C8.79004 5.03611 8.79004 4.79878 8.79004 4.68011C8.79004 4.68011 8.79004 4.91744 8.79004 5.03611H8.90852Z",
    fill: "#8E4520"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90852 4.7988H8.79004V4.56146V4.7988H8.90852Z",
    fill: "#231F20"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90852 6.2228V6.34146L8.79004 6.2228V6.10413L8.90852 6.2228Z",
    fill: "#8E4520"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90866 4.56146H8.6717V4.7988H8.55322V4.56146H8.79018H8.90866Z",
    fill: "#DAAC6D"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90869 4.56144C8.90869 4.56144 8.90869 4.56145 8.90869 4.44278C8.90869 4.44278 8.90869 4.56144 9.02717 4.56144H8.90869Z",
    fill: "#8F4620"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90883 5.74813L8.67188 5.5108C8.67188 5.5108 8.67187 5.74813 8.90883 5.74813Z",
    fill: "#8E4520"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79004 5.0361C8.79004 5.0361 8.79004 5.15477 8.79004 5.27344V5.0361V5.27344V5.0361H8.90852H8.79004Z",
    fill: "#231F20"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79035 5.86679L8.90883 6.10412C8.79035 6.10412 8.67188 5.86679 8.67188 5.86679H8.79035Z",
    fill: "#231F20"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79 5.74813H8.55305V5.5108H8.43457C8.43457 5.5108 8.55305 5.74813 8.67153 5.74813H8.79Z",
    fill: "#DAAC6D"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79032 6.10413H8.67184V5.8668H8.43489V5.5108H8.31641C8.31641 5.5108 8.55337 5.74813 8.67184 5.74813C8.67184 5.74813 8.67184 5.8668 8.79032 5.98547V6.10413Z",
    fill: "#231F20"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79035 5.39212H8.67188V5.15479H8.79035V5.39212Z",
    fill: "#8E4520"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79035 5.39212V5.51079L8.67188 5.39212V5.51079V5.39212H8.79035Z",
    fill: "#231F20"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79 5.74813H8.67153C8.67153 5.74813 8.55305 5.5108 8.43457 5.5108V5.62946H8.55305L8.79 5.74813Z",
    fill: "#4C2915"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55305 4.4428C8.55305 4.4428 8.55305 4.44279 8.55305 4.56145H8.43457V4.32413H8.55305V4.4428Z",
    fill: "#AA6C2A"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M8.67153 5.62946H8.43457C8.43457 5.62946 8.43457 5.74813 8.67153 5.86679V5.62946Z",
    fill: "#8E4520"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6717 4.79877V5.03609C8.6717 5.03609 8.6717 5.15476 8.55322 5.15476C8.55322 5.15476 8.55322 4.91743 8.55322 4.79877V5.03609C8.55322 5.03609 8.55323 4.91743 8.6717 4.79877Z",
    fill: "#DAAC6D"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55305 4.79877C8.55305 4.79877 8.55305 5.03609 8.43457 5.03609C8.43457 5.03609 8.43457 4.91743 8.43457 4.79877H8.55305Z",
    fill: "#8E4520"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55305 5.39211V5.51078H8.43457V5.39211V5.51078V5.39211V5.15477V5.0361V5.15477H8.55305L8.43457 5.27344H8.55305V5.39211Z",
    fill: "#DAAC6D"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55336 6.10413L8.31641 6.2228L8.55336 6.10413Z",
    fill: "#8E4520"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55336 5.74813C8.55336 5.74813 8.31641 5.62947 8.31641 5.5108C8.31641 5.5108 8.31641 5.62946 8.43489 5.74813H8.55336Z",
    fill: "#4C2915"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55336 6.10413C8.55336 6.10413 8.43488 6.2228 8.31641 6.34146H8.43489V6.10413H8.55336Z",
    fill: "#AA6C2A"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43489 4.68011H8.31641V4.44278V4.68011H8.43489Z",
    fill: "#DAAC6D"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43457 4.79878V4.91745V4.68011H8.55305L8.43457 4.79878Z",
    fill: "#8E4520"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43489 5.51078H8.31641C8.31641 5.51078 8.31641 5.39211 8.31641 5.27344C8.31641 5.27344 8.31641 5.15477 8.31641 5.0361V5.27344V5.51078H8.43489Z",
    fill: "#DAAC6D"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43489 5.39212V5.51079H8.31641V5.39212L8.43489 5.27345V5.15479V5.39212Z",
    fill: "#AA6C2A"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19775 5.5108C8.19775 5.5108 8.43471 5.8668 8.55319 5.98547C8.43471 5.98547 8.19775 5.62946 8.19775 5.62946V5.5108Z",
    fill: "#AA6C2A"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43489 5.0361V5.27344H8.31641V5.0361H8.43489Z",
    fill: "#8E4520"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43489 4.91745C8.43489 4.91745 8.43488 5.15478 8.31641 5.15478V4.91745H8.43489Z",
    fill: "#DAAC6D"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43471 5.86679V5.98546L8.19775 5.86679H8.31623H8.43471Z",
    fill: "#DAAC6D"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43457 5.86679V5.62946H8.55305V5.86679H8.43457Z",
    fill: "#8E4520"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M8.31606 4.56146C8.31606 4.56146 8.19758 4.56146 8.0791 4.56146H8.31606V4.32413V4.08679V4.32413H8.19758V4.4428C8.19758 4.4428 8.19758 4.44279 8.19758 4.56146H8.31606Z",
    fill: "#8F4620"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M8.31623 5.98547V6.10413H8.19775L8.31623 5.98547Z",
    fill: "#DAAC6D"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3162 5.98545H7.84229V5.74811V5.98545H8.3162Z",
    fill: "#BD9B37"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M8.31606 4.08679V4.32413H8.0791H8.19758C8.19758 4.32413 8.19758 4.32413 8.19758 4.20546C8.19758 4.20546 8.19758 4.32413 8.19758 4.4428H8.31606V4.08679Z",
    fill: "#DAAC6D"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19775 5.98547H8.31623L8.19775 6.10413H8.31623H8.19775V5.98547Z",
    fill: "#F8C73E"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19775 4.32411L8.31623 4.20544V4.32411H8.19775Z",
    fill: "#231F20"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19758 5.51078H8.0791V5.39211C8.0791 5.27344 8.0791 5.15477 8.0791 5.0361V5.27344C8.0791 5.39211 8.0791 5.39211 8.0791 5.39211C8.0791 5.39211 8.0791 5.27344 8.0791 5.15477C8.0791 5.15477 8.0791 5.27344 8.0791 5.39211L8.19758 5.51078Z",
    fill: "#AA6C2A"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19758 4.44278V4.56144H8.0791L8.19758 4.44278H8.0791H8.19758Z",
    fill: "#231F20"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19758 5.98547V6.10413H8.0791H8.19758V5.98547Z",
    fill: "#F8C73E"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19758 4.20546C8.19758 4.20546 8.19758 4.32413 8.0791 4.32413V4.08679L8.19758 4.20546Z",
    fill: "#8F4620"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19755 4.56146H7.72363V4.7988V4.56146H7.96059H8.19755Z",
    fill: "white"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19758 5.98547V6.10413H8.0791V5.98547H8.19758Z",
    fill: "#F8C73E"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19755 4.56146C8.19755 4.56146 8.19755 4.68013 7.96059 4.68013H7.72363H8.07907L8.19755 4.56146Z",
    fill: "#F8C73E"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07924 4.32412H7.96077C7.96077 4.32412 7.96076 4.32412 7.84229 4.32412V4.08678C7.84229 4.08678 7.84229 3.96812 7.84229 3.84946L8.07924 4.32412Z",
    fill: "#AA6C2A"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07941 4.68011C8.07941 4.68011 8.07942 4.68011 7.96094 4.68011C7.96094 4.68011 7.96094 4.79879 7.96094 4.91745H8.43485L8.07941 4.68011Z",
    fill: "#BC7E2F"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96077 5.98546V6.10412L7.84229 5.98546H7.96077V5.86679V5.98546Z",
    fill: "#F8C73E"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96077 4.44278V4.56144H7.84229L7.96077 4.44278Z",
    fill: "#F06D19"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96094 4.20544V4.44278C7.96094 4.44278 7.96093 4.20544 8.07941 4.20544H7.96094Z",
    fill: "#DAAC6D"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96094 4.20544V4.44278C7.96094 4.44278 8.07941 4.44278 8.07941 4.20544H7.96094Z",
    fill: "#231F20"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84229 5.98547L7.96077 6.10413H7.84229V5.98547Z",
    fill: "#F8C73E"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84211 5.86679V5.98546L7.72363 5.86679H7.84211Z",
    fill: "#F8C73E"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84211 6.10413H7.72363V5.98547H7.84211V6.10413Z",
    fill: "#F8C73E"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72363 5.98547H7.84211H7.72363V6.10413V5.98547Z",
    fill: "#F8C73E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1182_79154",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.7286 42.7147) rotate(13.5206) scale(0.0260681 0.026105)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6E11C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E82735"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1182_79154",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-8.84998 -48.1941) rotate(-32.0008) scale(0.0284482 0.028468)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC942"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#F8C741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#F0C140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E2B63D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CFA83A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD9B37"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1182_79154",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-8.88448 -47.1625) rotate(-32.0021) scale(0.0770445 0.0770997)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3798D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1182_79154",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.0323 69.2999) rotate(43.4668) scale(0.0711403 0.0711466)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3798D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1182_79154",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.3538 81.9324) rotate(43.4654) scale(0.0260854 0.0260877)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6E11C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E82735"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMxn);
export default __webpack_public_path__ + "static/media/MXN.14eb77c09d2b10f2ca08a80829d66fa8.svg";
export { ForwardRef as ReactComponent };